import { Component, input } from '@angular/core';
import { KENDO_CARD } from '@progress/kendo-angular-layout';
import { AgreementStatsDto } from '@unity/clients';

@Component({
  selector: 'unity-card-agreement-summary-shared',
  imports: [KENDO_CARD],
  templateUrl: './card-agreement-summary-shared.component.html',
  styleUrl: './card-agreement-summary-shared.component.scss',
})
export class CardAgreementSummarySharedComponent {
  public readonly $agreement = input.required<AgreementStatsDto | undefined>({ alias: 'agreement' });
}
